import React from 'react'
import { ScrollView } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Text } from '@components/base'
import { TutorialGroup } from '../models/tutorials.types'
import { TutorialPreview } from './TutorialPreview'

export const TutorialsGroup = ({ tutorialGroup }: { tutorialGroup: TutorialGroup }) => {
  const styles = useStyleSheet(themedStyle)
  const { summary, tutorials = [] } = tutorialGroup

  return (
    <SafeAreaView edges={['bottom']} style={styles.container}>
      <ScrollView contentContainerStyle={{ flexGrow: 1 }}>
        <Text type="regular" style={styles.summaryText}>
          {summary}
        </Text>
        {tutorials.map((tutorial) => (
          <TutorialPreview key={tutorial.id} tutorial={tutorial} />
        ))}
      </ScrollView>
    </SafeAreaView>
  )
}

const themedStyle = StyleService.create({
  container: {
    flex: 1,
    paddingHorizontal: 16,
    paddingBottom: 16,
    backgroundColor: 'theme.background',
  },
  summaryText: {
    marginVertical: 16,
    textAlign: 'center',
  },
})
